module.exports = __webpack_public_path__ + "static/img/sc6.48f4378.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/202104sc/sc6.png
// module id = 1kYH
// module chunks = 0